var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('loadingView',{attrs:{"isVisible":_vm.$root.isAllLoading}}),_c('GoTopButton'),_c('AlertView',{attrs:{"isVisible":_vm.$root.isAlert}}),(_vm.$root.isGuide && _vm.$root.deviceType !== 'web')?_c('GuideView'):_vm._e(),_c('StudentGmailModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }